import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import AdminHeader from '../../components/AdminHeader';
import Footer from '../../components/Footer';
import { useState, useEffect } from 'react';

function UserDashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    return window.innerWidth >= 1024;
  });

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <AdminHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
      <div className="flex flex-1">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <main
          className={`flex-1 p-4 lg:p-5 transition-all duration-300 mx-auto w-full max-w-full ${
            isSidebarOpen ? 'lg:ml-64' : 'lg:ml-16'
          }`}
        >
          <Outlet />
        </main>
      </div>
      <Footer className="fixed bottom-0 left-0 w-full" />
    </div>
  );
}

export default UserDashboardLayout;